export default __webpack_public_path__ + "static/media/reference-not-selected2_skyblue.12ace46c.svg";